// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_hy-0";
export var fulfillmentPanelBody = "_hy-1";